import { IconCoin, IconGiveMoney, IconVelocimeter } from '@consumidor-positivo/aurora';
import { RouteMap } from '@common/constants/RouteMap';

import { useRenegFallback } from '@common/hooks/useRenegFallback';

export const DataNavButtons = () => {
  const { isRenegFallback } = useRenegFallback();

  return [
    { label: 'Score', path: RouteMap.MyScore, icon: <IconVelocimeter /> },
    { label: 'Crédito', path: RouteMap.MyOffers, icon: <IconGiveMoney /> },
    { label: 'Dívidas', path: !isRenegFallback ? RouteMap.MyDebtsAC : RouteMap.MyCpf, icon: <IconCoin /> },
  ];
};
